import { get } from 'lodash-es';
import { replaceNullChars } from 'site-modules/shared/utils/string';

export function getSortedOptionDescriptions(vinData) {
  return get(vinData, 'vehicleInfo.partsInfo.optionDescriptions', [])
    .map(description => replaceNullChars(description))
    .filter(description => description.trim().length)
    .sort();
}
